import { styled } from "@material-ui/core/styles"
import { Link } from "react-router-dom";

export const Heading = styled('h1')(({ theme }) => ({
    color: theme.colors.mainBlue,
    fontWeight: 700,
    fontSize: '3rem',
}));

export const FormContainer = styled('div')(({ theme }) => ({
    width: '56.5rem',
    "@media only screen and (max-width: 468px)": {
        width: '100%',
    }
}));

export const ButtonContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'end',
    "@media only screen and (max-width: 768px)": {
        justifyContent: 'space-between',
    },
    "@media only screen and (max-width: 440px)": {
        flexDirection: 'column',
    }
}));

export const StyledLink = styled(Link)(({ theme }) => ({
    color: theme.colors.mainBlue,
    fontWeight: 700,
    fontSize: '1.2rem',
    textTransform: 'uppercase',
}));

export const InfoBlock = styled('div')(({ theme }) => ({
    display: 'flex',
    backgroundColor: theme.colors.white,
    width: '100%',
    padding: '1.4rem 1rem',
    alignItems: 'center',
}));

export const InfoBlockText = styled('p')(({ theme }) => ({
    fontSize: '1.2rem',
    fontWeight: '500',
    color: '#969696',
    marginLeft: '1.5rem'
}));